import React from "react";
import Input from "@components/forms/Input";

const SignInForm = ({ t, credentials, handleInputChange, handleLoginAttempt, loading, setStep }) => {
  const isFormValid = credentials.email && credentials.password;
  return (
    <>
      {/* <form className="d-flex flex-column gap-4">

        <div>
          <label className="form-label text-uppercase fw-bold small text-muted">
            Enterprise Email
          </label>
          <Input
            value={credentials.email}
            handleChange={handleInputChange("email")}
            placeholder={t("email")}
            type="email"
          />
        </div>

        <div>
          <label className="form-label text-uppercase fw-bold small text-muted">
            Password
          </label>
          <Input
            value={credentials.password}
            handleChange={handleInputChange("password")}
            placeholder={t("password")}
            type="password"
          />
        </div>

        <button
          type="button"
          className={`btn-custom w-100 py-3 rounded-3 fw-bold fs-5 shadow`}
          onClick={() => handleLoginAttempt(false)}
          disabled={!isFormValid || loading}
        >
          {loading ? t("loading") : t("to_log_in")}
        </button>
        <div className="d-flex justify-content-between small fw-semibold px-1">
          <span href="#" className="text-decoration-none cursor-pointer text-blue" onClick={() => setStep('forgot')}>Forgot access codes?</span>
          <a href="#" className="text-decoration-none text-blue">Request Access</a>
        </div>

      </form> */}

















<div className="mb-4">
        <Input
          value={credentials.email}
          handleChange={handleInputChange("email")}
          placeholder={t("email")}
          type="email"
        />
      </div>

      <div className="mb-4">
        <Input
          value={credentials.password}
          handleChange={handleInputChange("password")}
          placeholder={t("password")}
          type="password"
        />
      </div>

      <div className="d-grid mb-4">
        <button
          type="button"
          className={`btn p-3 btn-primary`}
          onClick={() => handleLoginAttempt(false)}
          // disabled={!isFormValid || loading}
        >
          {loading ? t("loading") : t("to_log_in")}
        </button>
      </div>

       <div className="d-flex justify-content-between my-3">
            <button
              type="button"
              className="btn btn-link text-primary text-decoration-none p-0"
              onClick={() => setStep('forgot')}
            >
              {t('forgot_password')}
            </button>
          </div> 
    </>
  );
};

export default SignInForm;
